








import Vue from 'vue'
import { oneOf } from '@/utils/helper'
export default Vue.extend({
  props: {
    size: {
      type: String,
      default: 'md',
      validator: oneOf(['sm', 'md', 'lg'])
    },
    type: {
      type: String,
      default: 'light',
      validator: oneOf(['light', 'dark', 'orange'])
    }
  },
  computed: {
    isStatic(): boolean {
      return process.env.NODE_ENV === 'storybook' || process.env.NODE_ENV === 'test'
    }
  }
})
